import Finiquitos from './Finiquitos'

const Multas = props => (
  <Finiquitos
    {...props}
    title='Multas'
    apiModel='multa'
    classification='3-2-3-36 Multa'
    showRut={false}
  />
)

export default Multas
